import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,linkFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';


import config from  '../../../../config';
import {
    UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT, ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS
} from "actions/actionTypes";
import moment   from 'moment'
class AdminReportsContractorTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }


    render() {


        return (
            <div className="top20 contractor-statistics-table databases-table">
                <BootstrapTable data={this.props.contractorData} ref='table'
                                remote={ true }
                               hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='Title'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Title'], format: (value) => {

                            return <span className='blue text-bold' >{value}</span>
                        }
                            }} editable={ false } dataSort={false}></TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='ContractorAverage'
                                       editable={ false } dataSort={false}>My Average</TableHeaderColumn>

                    <TableHeaderColumn width="35px" dataAlign="center" dataField='LastWeekContractorAverage'
                                       editable={ false } dataSort={false}>
                        <div>
                            <div>{'Last Week'}</div>
                            <div>  {this.props.oneWeekPeriodStartDate + ' - '  +  this.props.oneWeekPeriodEndDate}</div>
                        </div>
                    </TableHeaderColumn>

                    <TableHeaderColumn  columnClassName={'break-word'} width="35px" dataAlign="center" dataField='GoalReached'
                                         dataFormat={ customFormatter } formatExtraData={ {
                        path: ['GoalReached'], format: (value) => {
                         if (value== 'No'){
                             return  <span style={{color:'red'}}>{value}</span>
                         }else{
                             return  <span style={{color:'green'}}>{value}</span>
                         }
                        }}} dataSort={false}>Goal Reached?</TableHeaderColumn>

                    <TableHeaderColumn width="35px" dataAlign="center" dataField='BaseLineGoal'
                                       className="custom-header-cell"    editable={ false } dataSort={false}>Baseline Goal</TableHeaderColumn>


                    <TableHeaderColumn width="35px" dataAlign="center" dataField='StretchGoal'
                                       className="custom-header-cell"     editable={ false } dataSort={false}>Stretch Goal</TableHeaderColumn>

                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                        >Id</TableHeaderColumn>

                </BootstrapTable>

            </div>
        );
    }
}

export default AdminReportsContractorTable;
